import { useMemo, useRef, useState } from "react";
import useLoading from "../../../../../hooks/common/searchers/useLoading.js";
import useValue from "../../../../../hooks/forms/useValue.js";
import { generateOriginDestinationKey } from "../utils/keys.js";
const useSearcherFlightHotelContextState = ()=>{
    const [flightOperatives, setFlightOperatives] = useState({});
    const [discounts, setDiscounts] = useState([]);
    const [destinationAirports, setDestinationAirports] = useState({});
    const originValue = useValue({
        name: 'origin'
    });
    const destinationValue = useValue({
        name: 'destination'
    });
    const destinationAirportCallErrorLock = useRef(false);
    const destinationAirportCallLock = useRef(false);
    const discountsCallErrorLock = useRef(false);
    const discountsCallLock = useRef(false);
    const flightOperativeCallErrorLock = useRef(false);
    const flightOperativeCallLock = useRef(false);
    const { isLoading , doFetchLoading  } = useLoading([
        destinationAirportCallLock,
        discountsCallLock,
        flightOperativeCallLock
    ], !!destinationValue?.id);
    const originDestinationKey = useMemo(()=>generateOriginDestinationKey(originValue, destinationValue), [
        destinationValue,
        originValue
    ]);
    const flightOperative = useMemo(()=>flightOperatives[originDestinationKey], [
        flightOperatives,
        originDestinationKey
    ]);
    const destinationAirport = useMemo(()=>destinationValue?.id ? destinationAirports[destinationValue?.id] : undefined, [
        destinationAirports,
        destinationValue?.id
    ]);
    const { state , actions  } = useMemo(()=>({
            state: {
                flightOperative,
                flightOperatives,
                discounts,
                destinationAirport,
                destinationAirports,
                isLoading,
                originDestinationKey,
                callLocks: {
                    destinationAirportCallErrorLock,
                    destinationAirportCallLock,
                    discountsCallErrorLock,
                    discountsCallLock,
                    flightOperativeCallErrorLock,
                    flightOperativeCallLock
                }
            },
            actions: {
                setFlightOperatives,
                setDiscounts,
                setDestinationAirports,
                doFetchLoading
            }
        }), [
        destinationAirport,
        destinationAirports,
        discounts,
        doFetchLoading,
        flightOperative,
        flightOperatives,
        isLoading,
        originDestinationKey
    ]);
    return {
        state,
        actions
    };
};
export default useSearcherFlightHotelContextState;

//# sourceMappingURL=useContextState.js.map